// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"d6b874dc","931":"6015ebd0"}[chunkId] + ".chunk.css";
};